import { Nullable } from "@gemlightbox/core-kit";

export const validatePassword = (password: Nullable<string>) => {
  if (!password) return false;
  const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
  return re.test(password);
};
